import stl from "./BuyItWeDeliverItSingle.module.css";
import {CDN_LINK} from "@globalConfig";
import {useTranslation} from "@i18n";

const BuyItWeDeliverItSingle = ({ cityName }) => {

  const {t} = useTranslation();

  return (
    <>
      <div className={stl.BDC_container}>
        <div className={stl.BDC_content}>
          <h2>
            {t("اشتريها و نوصلها لباب بيتك في {{cityName}}", {
              ns: "web_city",
              cityName,
            })}
          </h2>
          <p>
            {t(
              "من خلال شاحنات شركة سيارة الحديثة نوفر خدمات إيصال السيارة المراد شرائها لين باب بيتك لضمان الراحة الكاملة التي نسعى لتوفيرها في أي مكان داخل منطقة {{cityName}} وكافة المحافظات السعودية",
              { ns: "web_city", cityName }
            )}
          </p>
        </div>
        <div className={stl.BDC_imageContainer}>
          <img
            src={CDN_LINK+"/assets/images/city/buy_it_we_deliver_it.webp"}
            alt="biggest collection of cars image"
            loading="lazy"
            width={450}
            height={200}
          />
        </div>
      </div>
    </>
  );
};

export default BuyItWeDeliverItSingle;
